/**
 * Main App component for CASCADES
 */

import { CascadeViewer } from './components/CascadeViewer';
import { ThemeProvider } from './contexts/ThemeContext';
import { SettingsProvider } from './contexts/SettingsContext';
import './App.css';

function App() {
  return (
    <SettingsProvider>
      <ThemeProvider>
        <div className="App">
          <CascadeViewer />
        </div>
      </ThemeProvider>
    </SettingsProvider>
  );
}

export default App
